import React from "react";

// base セクションの本体描画を担当します。
// section ごとの特殊表示はここで吸収し、呼び出し元は
// panel 解決と renderer 呼び出しだけを持つ形に寄せます。
export function renderBaseSectionBody({
    section,
    sectionPanel,
    totalHostPanel,
    renderContents,
    renderSustainableImagePanel,
    renderTotalGrid,
    sectionTotalType,
    isEmpty
}) {
    const bodyBoxStyle = {
        minHeight: 44,
        border: "1px solid #d0d0d0",
        borderRadius: 4,
        backgroundColor: "#fafafa",
        padding: "10px 12px",
        color: "#666"
    };

    let baseBody = null;

    if (!isEmpty(sectionPanel)) {
        baseBody = renderContents({ panel: sectionPanel });
    } else {
        baseBody = <div style={bodyBoxStyle}></div>;
    }

    // サステナブルだけは画像パネルを先頭に追加します。
    if (section.id === "sustainable") {
        baseBody = (
            <div>
                {renderSustainableImagePanel()}
                {baseBody}
            </div>
        );
    }

    // base セクションでも totalType を持つ場合は下部へ合計を追加します。
    const totaltype = sectionTotalType(section, totalHostPanel);
    if (!isEmpty(totaltype) && !isEmpty(totalHostPanel)) {
        baseBody = (
            <div>
                {baseBody}
                {renderTotalGrid(section, totalHostPanel, totaltype, false)}
            </div>
        );
    }

    return baseBody;
}
